
import marron1 from "../assets/Mallas imagen/marron.jpg";
import marron2 from "../assets/Mallas imagen/marron2.PNG";
import marron3 from "../assets/Mallas imagen/marron3.jpg";
import marron4 from "../assets/Mallas imagen/marron4.jpeg";
import azul1 from "../assets/Mallas imagen/azul.jpg";
import azul2 from "../assets/Mallas imagen/azul2.PNG";
import azul3 from "../assets/Mallas imagen/azul3.jpeg";
import azul4 from "../assets/Mallas imagen/azul4.jpeg";
import violeta1 from "../assets/Mallas imagen/violeta.jpeg";
import violeta2 from "../assets/Mallas imagen/violeta2.PNG";
import violeta3 from "../assets/Mallas imagen/violeta3.jpeg";
import violeta4 from "../assets/Mallas imagen/violeta4.jpeg";
import verde1 from "../assets/Mallas imagen/verde.PNG";
import verde2 from "../assets/Mallas imagen/verde2.PNG";
import verde3 from "../assets/Mallas imagen/verde3.jpg";
import verde4 from "../assets/Mallas imagen/verde4.jpeg";
import verde5 from "../assets/Mallas imagen/verde5.jpeg";
import calidad from "../assets/Mallas imagen/calidad.mp4";


import { useCarrito } from "../context/CarritoContext";
import guiadetalles from "../assets/Mallas imagen/guiadetalles.png";
import { useParams, Link } from "react-router-dom";
import { useEffect, useRef, useState, useCallback } from "react";
import { Truck as TruckIcon } from "lucide-react";
import { FaCreditCard } from "react-icons/fa";



const productos = [
  {
    id: "boardshort-1",
    nombre: "The Sunset",
    img: marron1,
    desc: "Colores cálidos y diseño clásico para días de verano.",
    precio: "$75.200",
    imagenes: [
      marron1,
      marron3,
      marron4,
      marron2
    ],
  },
  {
    id: "boardshort-2",
    nombre: "The Ocean",
    img: azul1,
    desc: "Inspirada en el mar, cómoda y fresca.",
    precio: "$75.200,00",
    imagenes: [
      azul1,
      azul3,
      azul4,
      azul2
    ],
  },
  {
    id: "boardshort-3",
    nombre: "The Sundown",
    img: violeta1,
    desc: "Estampado tropical y alegre, ideal para la playa.",
    precio: "$75.200,00",
        imagenes: [
      violeta1,
      violeta3,
      violeta4,
      violeta2
    ],
  },
  {
    id: "boardshort-4",
    nombre: "The Tropic",
    img: verde1,
    desc: "Diseño minimalista y versátil.",
    precio: "$75.200,00",
        imagenes: [
      verde1,
      verde3,
      verde4,
      verde2
    ],
  },
];



function GaleriaProducto({ imagenes = [], alt = "" }) {
  const imgs = Array.isArray(imagenes) ? imagenes : [];
  const trackRef = useRef(null);
  const [idx, setIdx] = useState(0);

  // Actualiza índice al hacer scroll manual del visor principal
  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    const onScroll = () => {
      const w = el.clientWidth || 1;
      const i = Math.round(el.scrollLeft / w);
      if (i !== idx) setIdx(i);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [idx]);

  // Ir a una imagen concreta
  const scrollTo = (i) => {
    const el = trackRef.current;
    if (!el) return;
    const w = el.clientWidth || 1;
    el.scrollTo({ left: i * w, behavior: "smooth" });
    setIdx(i);
  };

  if (!imgs.length) return null;

return (
  <div className="w-full relative md:pl-[104px]"> {/* 96px thumbs + 8px gap */}
    {/* ===== DESKTOP/TABLET: thumbs a la izquierda ===== */}
    {imgs.length > 1 && (
      <div className="hidden md:flex flex-col gap-2 w-[96px] absolute left-0 top-0 max-h-[620px] overflow-auto no-scrollbar">
        {imgs.map((src, i) => (
          <button
            key={i}
            onClick={() => scrollTo(i)}
            className={`relative w-[96px] h-[96px] overflow-hidden border
                        ${i === idx ? "border-gray-900" : "border-gray-200 hover:border-gray-400"}`}
            aria-label={`Miniatura ${i + 1}`}
          >
            <img src={src} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    )}

      {/* Visor principal (scroll con snap, sin mostrar barra) */}
      <div className="relative">
        <div
          ref={trackRef}
          className="w-full overflow-x-auto no-scrollbar scroll-smooth snap-x snap-mandatory flex gap-0"
          aria-label="Galería de imágenes"
        >
          {imgs.map((src, i) => (
            <div key={i} className="w-full shrink-0 snap-center">
              <div className="aspect-[3/4] md:aspect-[3/4] lg:aspect-[4/5] w-full overflow-hidden bg-gray-50">
                <img
                  src={src}
                  alt={alt || `Foto ${i + 1}`}
                  className="w-full h-full object-cover"
                  loading={i === 0 ? "eager" : "lazy"}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ===== MOBILE: puntitos (chicos), desktop no muestra puntitos ===== */}
      {imgs.length > 1 && (
        <div className="flex items-center justify-center gap-4 mt-4 md:hidden">
          {imgs.map((_, i) => (
            <button
              key={i}
              aria-label={`Ir a foto ${i + 1}`}
              onClick={() => scrollTo(i)}
              className={`w-1.5 h-1.5 rounded-full transition ${i === idx ? "bg-black" : "bg-gray-300"}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}


export default function ProductoDetalle() {
  const { id } = useParams();
  // const navigate = useNavigate(); // sin uso
  const producto = productos.find((p) => p.id === id);
  const [talle, setTalle] = useState("M");
  const { agregarAlCarrito, showAddBanner } = useCarrito();

  // === URL de tu Apps Script
  const APPS_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbxKBBXYRSBER0Tc58E5XE90boKmHt8dRUi1H6uMcwd53l_8kUGGkJXcSq8D09nBckQ_/exec";

  // === SOLO LECTURA de stock (desde Sheets)
  const [stockPorTalle, setStockPorTalle] = useState(null);
  const [cargandoStock, setCargandoStock] = useState(false);
  const [errorStock, setErrorStock] = useState("");
  const productName = producto?.nombre ?? "";

  useEffect(() => {
    let cancel = false;
    const cacheKey = `stock:${productName}`;
    const cache = (window.__stockCache = window.__stockCache || new Map());

    if (!productName) {
      setStockPorTalle(null);
      setErrorStock("");
      return () => {
        cancel = true;
      };
    }

    // Usa caché de sesión si ya existe
    if (cache.has(cacheKey)) {
      setStockPorTalle(cache.get(cacheKey));
      setErrorStock("");
      setCargandoStock(false);
      return () => {
        cancel = true;
      };
    }

    (async () => {
      try {
        setCargandoStock(true);
        setErrorStock("");

        const resp = await fetch(APPS_SCRIPT_URL, {
          method: "POST",
          headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify({ action: "stock", producto: productName }),
        });

        const json = await resp.json();
        if (cancel) return;

        if (!json?.ok) {
          setErrorStock(json?.error || "No se pudo obtener stock");
          setStockPorTalle(null);
          return;
        }

        const map = {};
        (json.talles || []).forEach(({ talle, stock }) => {
          const t = String(talle || "").trim();
          const s = Number(stock || 0);
          map[t] = (map[t] || 0) + s;
        });

        cache.set(cacheKey, map);
        setStockPorTalle(map);

        // Si el talle actual quedó sin stock, ajusta a uno disponible
        if ((map[talle] ?? 0) <= 0) {
          const orden = ["XS", "S", "M", "L", "XL", "XXL", "Único"];
          const candidato = orden.find((t) => (map[t] ?? 0) > 0);
          if (candidato && candidato !== talle) setTalle(candidato);
        }
      } catch {
        if (!cancel) {
          setErrorStock("No se pudo obtener stock");
          setStockPorTalle(null);
        }
      } finally {
        if (!cancel) setCargandoStock(false);
      }
    })();

    return () => {
      cancel = true;
    };
    // 👇 Importante: SOLO depende del producto
  }, [productName, talle]);

  // ===== Resto de estados/UX =====
  const [cantidad, setCantidad] = useState(1);
  const inc = () => setCantidad((c) => Math.min(99, c + 1));
  const dec = () => setCantidad((c) => Math.max(1, c - 1));
  const onCantidadChange = (e) => {
    const v = Number(e.target.value.replace(/\D/g, "")) || 1;
    setCantidad(Math.min(99, Math.max(1, v)));
  };

  const [guiaAbierta, setGuiaAbierta] = useState(false);
  const [pagoAbierto, setPagoAbierto] = useState(false);
  const [cambiosAbierto, setCambiosAbierto] = useState(false);

  // ===== Video (autoplay al abrir) =====
  const [calidadAbierta, setCalidadAbierta] = useState(false);
  const videoSrc = producto?.video || calidad; // usa el del producto o el import 'calidad'
  const posterSrc = producto?.poster || undefined;
  const videoRefMobile = useRef(null);
  const videoRefDesktop = useRef(null);

  useEffect(() => {
    const vids = [videoRefMobile.current, videoRefDesktop.current].filter(Boolean);
    if (calidadAbierta) {
      vids.forEach((v) => v?.play?.().catch(() => {}));
    } else {
      vids.forEach((v) => v?.pause?.());
    }
  }, [calidadAbierta]);

  const guiaAnchorRef = useRef(null);
  const handleIrAGuia = () => {
    setGuiaAbierta(true);
    requestAnimationFrame(() => {
      guiaAnchorRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  // ====== Relacionados ======
  const relacionados = productos.filter((p) => p.id !== id).slice(0, 8);

  const relScrollRef = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const updateArrows = useCallback(() => {
    const el = relScrollRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setCanPrev(scrollLeft > 2);
    setCanNext(scrollLeft + clientWidth < scrollWidth - 2);
  }, []);

  useEffect(() => {
    const el = relScrollRef.current;
    if (!el) return;
    updateArrows();
    el.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [updateArrows, relacionados.length]);

  const scrollByCard = (dir) => {
    const el = relScrollRef.current;
    if (!el) return;
    const card = el.querySelector(".rel-card");
    const gap = 8; // aprox
    const delta = card ? card.clientWidth + gap : el.clientWidth * 0.9;
    el.scrollBy({ left: dir === "next" ? delta : -delta, behavior: "smooth" });
  };

  const handleAgregar = useCallback(() => {
    // 🔒 Si todavía no llegó el stock, no dejamos agregar
    if (cargandoStock || !stockPorTalle) return;

    const stockSelLocal = stockPorTalle[talle] ?? 0;
    if (stockSelLocal <= 0) return;

    for (let i = 0; i < cantidad; i++) {
      agregarAlCarrito(producto, talle);
    }
    showAddBanner({ ...producto, talle, cantidad });
  }, [cargandoStock, stockPorTalle, talle, cantidad, agregarAlCarrito, showAddBanner, producto]);

  if (!producto) {
    return <div className="p-8 text-center">Producto no encontrado</div>;
  }

  const formatPrice = (n) =>
    typeof n === "number"
      ? n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : n;

  const precioBaseNum =
    typeof producto.precio === "number"
      ? producto.precio
      : Number(String(producto.precio).replace("$", "").replace(/\./g, "").replace(",", "."));

  const precioOriginalNum = isFinite(precioBaseNum) ? precioBaseNum : 0;

  // 30% OFF (redondeo a 100)
  const precio30Num = Math.floor((precioOriginalNum * 0.70) / 100) * 100;

  const precioOriginalFmt = formatPrice(precioOriginalNum);
  const precio30Fmt = formatPrice(precio30Num);

  // Transferencia -15% sobre el precio 30% OFF
  const precioTransfNum = Math.floor((precio30Num * 0.85) / 100) * 100;
  const precioTransfFmt = formatPrice(precioTransfNum);

  // Cuotas sobre el precio 30% OFF
  const cuotaBaseFmt = formatPrice(precio30Num / 3);

  const offPercent =
    isFinite(precioBaseNum) && precioBaseNum > 0
      ? Math.round((1 - precioTransfNum / precioBaseNum) * 100)
      : 0;

  const stockSel = stockPorTalle ? (stockPorTalle[talle] ?? 0) : null;
  const avisoSel =
    stockSel == null
      ? ""
      : stockSel <= 0
      ? "Agotado"
      : stockSel === 1
      ? "¡Última unidad!"
      : stockSel <= 3
      ? "¡Últimas unidades!"
      : "";

  // === Texto de descripción compartido ===
  const descContenido = (
    <div className="text-xs pd-onepalm text-gray-800 space-y-1">
      <p>
        <strong>Tela:</strong> Poliéster 92% + Elastano 8%.
      </p>
      <p>
        <strong>Por qué Poliéster:</strong> liviano, <strong>secado rápido</strong>,
        resistente al desgaste y <strong>no pierde el color</strong>.
      </p>
      <p>
        <strong>Por qué Elastano:</strong> <strong>elasticidad 4-way</strong>, ajuste cómodo y{" "}
        <strong>no se deforma ni cede con el uso</strong>.
      </p>
    </div>
  );

  return (
    <div className="max-w-[1100px] md:mx-auto mx-0 px-4 pb-2 pt-24 md:pt-28">
      {/* ⬇️ más espacio SOLO desktop */}
      <div className="flex flex-col md:flex-row items-start mt-1 gap-0 md:gap-10">
        <div className="flex-1 md:pt-10">
          <div className="w-screen -mx-4 md:w-auto md:mx-0 h-[75vh] md:h-auto overflow-hidden">
            <GaleriaProducto
              imagenes={producto.imagenes?.length ? producto.imagenes : [producto.img]}
              alt={producto.nombre}
            />
          </div>
        </div>

        {/* ⬇️ más respiro vertical SOLO desktop */}
        <div className="flex-1 space-y-1 md:space-y-4 md:pt-12 text-left">
          <h1 className="text-md nav-onepalm text-gray-900 mb-3 md:mb-2">{producto.nombre}</h1>

          {/* === PRECIO + CUOTAS (SOLO MOBILE: cuotas a la derecha) === */}
          {/* === PRECIO + CUOTAS (SOLO MOBILE: cuotas a la derecha) === */}
          <div className="md:hidden flex items-baseline justify-between gap-2 mt-0.5">
            <div className="flex flex-col">
              <div className="flex items-baseline gap-2">
                <span className="text-[12px] text-gray-500 line-through proba">
                  ${precioOriginalFmt}
                </span>
                <span className="text-[12px] text-gray-900 proba font-semibold">
                  ${precio30Fmt}
                </span>
              </div>

              <span className="text-[10px] font-semibold text-red-600 proba mt-0.5">
                30% OFF
              </span>
              </div>

              <div className="text-[10px] text-gray-800 pd-onepalm whitespace-nowrap flex items-center gap-1">
          <span>3 cuotas sin interés de</span>
          <span className="text-gray-900 proba">${cuotaBaseFmt}</span>
          <FaCreditCard className="w-3 h-3" strokeWidth={1.75} aria-hidden="true" />
          </div>
        </div>

          {/* Precio base (desktop) con margen */}
          <div className="hidden md:flex items-baseline gap-2 md:mt-2">
            <span className="text-md text-gray-500 line-through nav-onepalm">${precioOriginalFmt}</span>
            <span className="text-md text-gray-900 nav-onepalm font-semibold">${precio30Fmt}</span>
            <span className="text-xs font-semibold text-red-600 nav-onepalm">30% OFF</span>
          </div>

          {/* Precio en transferencia */}
          <div className="text-md mt-1 mb-1 md:mt-3">
            <span className="inline-flex items-baseline gap-1 px-0 py-0 rounded-full text-green-700 whitespace-nowrap">
              <span className="text-[12px] font-semibold proba leading-none md:text-[16px]">
                ${precioTransfFmt}
              </span>
              <span className="text-[10px] pd-oneálm leading-none">en Transferencia</span>
            </span>
          </div>

          {/* Línea divisoria corta (solo mobile) */}
          <div className="md:hidden mx-auto h-px w-[97%] bg-gray-300/70 !mt-2 !mb-2" />

          {/* 3 CUOTAS (desktop) con más margen */}
          <div className="hidden md:flex text-sm text-black-900 mt-3 items-center gap-1.5 pd-onepalm">
            <span>3 cuotas sin interés de</span>
            <span className="inline-flex items-center gap-1 font-semibold">
              ${cuotaBaseFmt} 
              <FaCreditCard className="w-4 h-4" strokeWidth={1.75} aria-hidden="true" />
            </span>
          </div>

          {/* Aviso de stock */}
          {(errorStock || avisoSel) && (
            <div className="mt-1 md:mt-2">
              {errorStock ? (
                <span className="text-xs text-red-600">{errorStock}</span>
              ) : (
                <span className="text-sm nav-onepalm font-semibold text-red-600">
                  {avisoSel}
                </span>
              )}
            </div>
          )}

          {/* Envío — solo DESKTOP */}
          <div className="hidden md:block mt-3">
            <div className="flex items-center text-xs pd-onepalm text-gray-700">
              <TruckIcon className="mr-1 w-4 h-4" aria-hidden="true" />
              <span>Envío gratis a todo el pais</span>
            </div>
          </div>

          {/* Talle */}
          <div className="mt-1 md:mt-4">
            {/* Fila: Talle + Envío SOLO MOBILE */}
            <div className="flex items-center justify-between md:hidden">
              <label className="text-[12px] pd-onepalm text-gray-900">Talle</label>
              <div className="flex items-center text-[10px] pd-onepalm text-gray-900">
                <TruckIcon className="mr-1 w-4 h-4" aria-hidden="true" />
                <span>Envío gratis a todo el pais</span>
              </div>
            </div>

            {/* === MOBILE: botones cuadrados chicos === */}
            <div className="md:hidden mt-2">
              <div className="grid grid-cols-3 gap-2 w-28">
                {["S", "M", "L", "XL"].map((t) => {
                  const st = stockPorTalle ? (stockPorTalle[t] ?? null) : null;
                  const disabled = st != null && st <= 0;
                  const isActive = talle === t;
                  return (
                    <button
                      key={t}
                      type="button"
                      onClick={() => !disabled && setTalle(t)}
                      disabled={disabled}
                      aria-pressed={isActive}
                      className={[
                        "h-7 w-7 rounded-none text-xs font-medium transition ",
                        "border border-black",
                        isActive ? "bg-gray-600 text-white" : "bg-gray-100 text-gray-900",
                        disabled ? "opacity-30 cursor-not-allowed" : "hover:bg-gray-600 active:scale-95",
                      ].join(" ")}
                    >
                      {t}
                    </button>
                  );
                })}
              </div>

              <button
                type="button"
                onClick={handleIrAGuia}
                className="block text-xs underline pd-onepalm text-gray-900 mt-2"
                role="link"
              >
                Guía de talles
              </button>
            </div>

            {/* === DESKTOP: select original === */}
            <div className="hidden md:block">
              <select
                id="talle"
                value={talle}
                onChange={(e) => setTalle(e.target.value)}
                className="border font-cabinet border-gray-300 rounded-md px-4 py-2 w-48"
              >
                {["S", "M", "L", "XL"].map((t) => {
                  const st = stockPorTalle ? (stockPorTalle[t] ?? null) : null;
                  const labelBase = t === "S" ? "Small (30)" : t === "M" ? "Medium (32)" : t === "L" ? "Large (34)" :
                                    "XL (36)";
                  const sufijo =
                    st == null ? "" : st <= 0 ? " — Agotado" : st === 1 ? " — ¡Última!" : "";
                  return (
                    <option key={t} value={t} disabled={st != null && st <= 0}>
                      {labelBase}
                      {sufijo}
                    </option>
                  );
                })}
              </select>

              <button
                type="button"
                onClick={handleIrAGuia}
                className="block text-sm underline text-gray-900 mt-2"
                role="link"
              >
                Guía de talles
              </button>
            </div>
          </div>

          {/* Cantidad con más aire desktop */}
          <div className="pt-1 md:pt-1">
            <label className="block text-[12px] pd-onepalm text-gray-900 mb-1">Cantidad:</label>
            <div className="inline-flex items-center border border-gray-300 overflow-hidden">
              <button type="button" onClick={dec} className="px-3 py-1.5 select-none" aria-label="Disminuir cantidad">
                –
              </button>
              <input
                inputMode="numeric"
                pattern="[0-9]*"
                value={cantidad}
                onChange={onCantidadChange}
                className="w-12 text-center outline-none py-1.5 font-cabinet"
              />
              <button type="button" onClick={inc} className="px-3 py-1.5 select-none" aria-label="Aumentar cantidad">
                +
              </button>
            </div>
          </div>

          {/* Agregar al carrito */}
          <div className="flex flex-col sm:flex-row gap-4 md:gap-6 pt-4 md:pt-2">
            <button
              onClick={handleAgregar}
              disabled={stockSel != null && stockSel <= 0}
              className="w-full nav-onepalm text-xs sm:w-auto border border-transparent bg-gray-600 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed text-white px-6 py-3 shadow-sm hover:bg-white hover:text-gray-600 hover:border-black active:scale-95 transition"
            >
              Agregar al carrito
            </button>

            {/* Descripción SOLO MOBILE */}
            <div className="md:hidden w-full mt-1">
              {descContenido}

              {/* NUESTRA CALIDAD (VIDEO) — MOBILE */}
              <div className="mt-3">
                <button
                  type="button"
                  onClick={() => setCalidadAbierta((v) => !v)}
                  aria-expanded={calidadAbierta}
                  aria-controls="panel-nuestra-calidad-mobile"
                  className="text-xs pd-onepalm underline text-gray-900 text-left"
                >
                  Nuestra calidad
                </button>
                <div
                  id="panel-nuestra-calidad-mobile"
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    calidadAbierta ? "max-h-[1200px] mt-2" : "max-h-0"
                  }`}
                >
                  <div className="w-full aspect-video max-h-[520px] rounded-md overflow-hidden bg-black">
                    {calidadAbierta && (
                      <video
                        ref={videoRefMobile}
                        className="w-full h-full"
                        autoPlay
                        playsInline
                        loop
                        preload="auto"
                        controls
                        poster={posterSrc}
                      >
                        <source src={videoSrc} type="video/mp4" />
                        Tu navegador no soporta el video .
                      </video>
                    )}
                  </div>
                </div>
              </div>
              {/* FIN VIDEO MOBILE */}
            </div>
          </div>

          {/* Descripción SOLO DESKTOP con más respiro */}
          <div className="hidden sm:block mt-4 space-y-3">
            {descContenido}

            {/* NUESTRA CALIDAD (VIDEO) — DESKTOP */}
            <div className="mt-3">
              <button
                type="button"
                onClick={() => setCalidadAbierta((v) => !v)}
                aria-expanded={calidadAbierta}
                aria-controls="panel-nuestra-calidad-desktop"
                className="text-sm underline text-gray-900 text-left"
              >
                Nuestra calidad
              </button>
              <div
                id="panel-nuestra-calidad-desktop"
                className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                  calidadAbierta ? "max-h-[1200px] mt-2" : "max-h-0"
                }`}
              >
                <div className="w-full aspect-video max-h-[520px] rounded-md overflow-hidden bg-black">
                  {calidadAbierta && (
                    <video
                      ref={videoRefDesktop}
                      className="w-full h-full"
                      autoPlay
                      playsInline
                      loop
                      preload="auto"
                      controls
                      poster={posterSrc}
                    >
                      <source src={videoSrc} type="video/mp4" />
                      Tu navegador no soporta el video HTML5.
                    </video>
                  )}
                </div>
              </div>
              {/* FIN VIDEO DESKTOP */}
            </div>
          </div>
        </div>
      </div>

      {/* ===== Acordeones simples ===== */}
      <section className="mt-10">
        <div ref={guiaAnchorRef} className="h-0 scroll-mt-24 md:scroll-mt-28" aria-hidden="true" />

        {/* Guía de talles */}
        <div className="border-t first:border-t-0">
          <button
            type="button"
            onClick={() => setGuiaAbierta((v) => !v)}
            aria-expanded={guiaAbierta}
            aria-controls="acc-guia"
            className="w-full flex items-center justify-between px-0 py-3 text-left"
          >
            <div className="flex items-center gap-2">
              <span className="text-gray-900 nav-onepalm text-xs">Guía de talles</span>
            </div>
            <svg
              className={`h-5 w-5 text-gray-700 transition-transform ${guiaAbierta ? "rotate-180" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            id="acc-guia"
            className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
              guiaAbierta ? "max-h-[2000px]" : "max-h-0"
            }`}
          >
            <div className="pb-4">
              <figure className="w-full">
                <img
                  src={guiadetalles}
                  alt="Guía de talles (Cintura, Cadera, Largo y Tiro)"
                  className="w-full md:max-w-[700px] lg:max-w-[800px] mx-auto h-auto rounded-md shadow-sm"
                  loading="lazy"
                />
              </figure>
            </div>
          </div>
        </div>

        {/* Medios de pago */}
        <div className="border-t">
          <button
            type="button"
            onClick={() => setPagoAbierto((v) => !v)}
            aria-expanded={pagoAbierto}
            aria-controls="acc-pago"
            className="w-full flex items-center justify-between px-0 py-3 text-left"
          >
            <div className="flex items-center gap-2">
              <span className="text-gray-900 text-xs nav-onepalm">Medios de pago</span>
            </div>
            <svg
              className={`h-5 w-5 text-gray-700 transition-transform ${pagoAbierto ? "rotate-180" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            id="acc-pago"
            className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
              pagoAbierto ? "max-h-[600px]" : "max-h-0"
            }`}
          >
            <div className="pb-4 text-xs text-gray-800 space-y-1.5 pd-onepalm font-semibold">
              <p>Mercado Pago — 3 cuotas sin interes.</p>
              <p className="text-gray-800 font-semibold">Transferencia bancaria — {offPercent}% OFF</p>
            </div>
          </div>
        </div>

        {/* Cambios y devoluciones */}
        <div className="border-t">
          <button
            type="button"
            onClick={() => setCambiosAbierto((v) => !v)}
            aria-expanded={cambiosAbierto}
            aria-controls="acc-cambios"
            className="w-full flex items-center justify-between px-0 py-3 text-left"
          >
            <div className="flex items-center gap-2">
              <span className="text-gray-900 nav-onepalm text-xs">Cambios y devoluciones</span>
            </div>
            <svg
              className={`h-5 w-5 text-gray-700 transition-transform ${cambiosAbierto ? "rotate-180" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            id="acc-cambios"
            className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
              cambiosAbierto ? "max-h-[600px]" : "max-h-0"
            }`}
          >
            <div className="pb-4 text-xs font-semibold text-gray-800 space-y-2 pd-onepalm">
              <p>
                Leé nuestra{" "}
                <Link to="/devolucion" className="underline text-gray-900">
                  Política de Devolución
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Productos Relacionados (igual que en Hero) ===== */}
      <section className="mt-12">
        <h2 className="text-md text-center sm:text-xl nav-onepalm text-gray-900 mb-4 px-1">
          Otros Boards
        </h2>

        {/* sprite SVG oculto para flechas */}
        <svg aria-hidden="true" className="absolute w-0 h-0 overflow-hidden">
          <defs>
            <symbol id="arrow-long" viewBox="0 0 24 24">
              <path
                d="M3 12h16m0 0-5-5m5 5-5 5"
                fill="none"
                stroke="currentColor"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </symbol>
          </defs>
        </svg>

        <style>{`
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .hide-scrollbar::-webkit-scrollbar { display: none; }
        `}</style>

        {/* Mobile: lista horizontal (clonado del estilo de Hero) */}
        <div className="block lg:hidden w-full">
          <div
            ref={relScrollRef}
            className="overflow-x-auto hide-scrollbar flex gap-4 px-1 sm:px-2 scroll-smooth snap-x snap-mandatory"
          >
            {relacionados.map((p) => {
              const precioNum =
                typeof p.precio === "number"
                  ? p.precio
                  : Number(String(p.precio).replace("$", "").replace(/\./g, "").replace(",", ".")) ||
                    0;

              const precioFmt = (n) =>
                n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

              const precio30Num = Math.floor((precioNum * 0.70) / 100) * 100;
              const precioTransfNum = Math.floor((precio30Num * 0.85) / 100) * 100;
              const precioTransfFmt = precioFmt(precioTransfNum);
              const cuota3 = precio30Num / 3;

              return (
                <Link
                  key={p.id}
                  to={`/producto/${p.id}`}
                  className="rel-card group flex-none w-[70%] sm:w-[280px] snap-start shrink-0"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  <div className="aspect-[4/5] overflow-hidden">
                    <img
                      src={p.img}
                      alt={p.nombre}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                      loading="lazy"
                    />
                  </div>

                  {/* === Datos iguales a Hero === */}
                  <div className="mt-2 mb-1">
                    <h3 className="nav-onepalm text-center text-gray-900 text-sm line-clamp-2 mt-3">
                      {p.nombre}
                    </h3>

                    {/* precio base */}
                    <div className="flex justify-center items-baseline gap-2 mt-1">
                      <span className="text-xs text-gray-500 line-through proba">${precioFmt(precioNum)}</span>
                      <span className="text-xs font-semibold text-gray-900 proba">${precioFmt(precio30Num)}</span>
                      <span className="text-[9px] font-semibold text-red-600 proba">30% OFF</span>
                    </div>

                    {/* PRECIO TRANSFERENCIA */}
                    <div className="text-xs mt-1 text-center">
                      <span className="inline-flex items-baseline gap-1 text-green-700 whitespace-nowrap">
                        <span className="text-xs leading-none proba">
                          ${precioTransfFmt}
                        </span>
                        <span className="text-[9px] prueba leading-none">en Transferencia</span>
                      </span>
                    </div>

                    {/* 3 CUOTAS */}
                    <div className="text-[10px] lg:text-sm text-black-900 mt-1 items-center gap-1.5 prueba text-center">
                      <span>3 cuotas sin interés de </span>
                      <span className="inline-flex items-center gap-1 font-semibold proba">
                        ${precioFmt(cuota3)} <FaCreditCard className="w-3 h-3" aria-hidden="true" />
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>

          {/* Flechas abajo (Hero-like) */}
          <div className="flex items-center justify-between px-3 mt-5 select-none">
            <svg
              viewBox="0 0 24 24"
              aria-label="Anterior"
              role="img"
              onClick={canPrev ? () => scrollByCard("prev") : undefined}
              className={`${
                canPrev ? "text-gray-900 cursor-pointer" : "text-gray-900 pointer-events-none"
              } w-[30px] h-[30px] transition-transform hover:scale-105 active:scale-95 rotate-180`}
            >
              <use href="#arrow-long" xlinkHref="#arrow-long" />
            </svg>

            <svg
              viewBox="0 0 24 24"
              aria-label="Siguiente"
              role="img"
              onClick={canNext ? () => scrollByCard("next") : undefined}
              className={`${
                canNext ? "text-gray-900 cursor-pointer" : "text-gray-900 pointer-events-none"
              } w-[30px] h-[30px] transition-transform hover:scale-105 active:scale-95`}
            >
              <use href="#arrow-long" xlinkHref="#arrow-long" />
            </svg>
          </div>
        </div>

        {/* Desktop: grilla con los mismos “datos” que Hero */}
        <div className="hidden lg:grid grid-cols-4 gap-4">
          {relacionados.map((p) => {
            const precioNum =
              typeof p.precio === "number"
                ? p.precio
                : Number(String(p.precio).replace("$", "").replace(/\./g, "").replace(",", ".")) ||
                  0;

            const precioFmt = (n) =>
              n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            const precio30Num = Math.floor((precioNum * 0.70) / 100) * 100;
            const precioTransfNum = Math.floor((precio30Num * 0.85) / 100) * 100;
            const precioTransfFmt = precioFmt(precioTransfNum);
            const cuota3 = precio30Num / 3;

            return (
              <Link
                key={p.id}
                to={`/producto/${p.id}`}
                className="group block"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={p.img}
                    alt={p.nombre}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                    loading="lazy"
                  />
                </div>

                {/* === Datos clonados de Hero (estética consistente) === */}
                <div className="mt-2 mb-1">
                  <h3 className="nav-onepalm text-gray-800 text-[16px] line-clamp-2 text-center">
                    {p.nombre}
                  </h3>

                  {/* precio base */}
                  <div className="flex justify-center items-baseline gap-2 mt-1">
                    <span className="text-[14px] text-gray-500 line-through proba">${precioFmt(precioNum)}</span>
                    <span className="text-[14px] text-gray-900 font-semibold proba">${precioFmt(precio30Num)}</span>
                    <span className="text-[10px] font-semibold text-red-600 proba">30% OFF</span>
                  </div>

                  {/* precio transferencia */}
                  <p className="text-[14px] text-green-700 leading-tight mt-1 text-center">
                    <span className="text-md nav-onepalm leading-none">
                      ${precioTransfFmt}
                    </span>
                    <span className="text-[10px] nav-onepalm leading-none"> en Transferencia</span>
                  </p>

                  {/* cuotas */}
                  <div className="text-[12px] text-black-900 mt-1 font-medium prueba text-center">
                    3 cuotas sin interés de{" "}
                    <span className="font-semibold">${precioFmt(cuota3)}</span>
                    <FaCreditCard className="w-4 h-4 inline-block ml-1 align-[-2px]" aria-hidden="true" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}